import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

const TEAL = "#06b6a4";

const VIEW_TYPES = [
  { value: "on_screen", label: "On Screen" },
  { value: "pdf", label: "PDF" },
  { value: "excel", label: "Excel" },
  { value: "email", label: "Email" },
];

const ASSET_CLASSES = [
  { value: "mutual_fund", label: "Mutual Fund" },
  { value: "share_bond", label: "Share & Bond" },
];

const REPORT_COLUMNS = [
  { key: "investor", label: "Investor" },
  { key: "folio", label: "Folio" },
  { key: "scheme_name", label: "Scheme Name" },
  { key: "units_sold", label: "Units Sold (₹)" },
  { key: "amount", label: "Amount (₹)" },
  { key: "purchase_cost", label: "Purchase Cost (₹)" },
  { key: "profit_loss", label: "Profit/Loss (₹)" },
  { key: "dividend", label: "Dividend (₹)" },
  { key: "holding_days", label: "Holding Days (₹)" },
  { key: "absolute_return", label: "Absolute Return (%)" },
  { key: "cagr", label: "CAGR (%)" },
  { key: "stt", label: "STT (₹)" },
];

const inputBorderStyle = { borderRadius: "8px", border: `1px solid ${TEAL}` };

export default function ProfitLoss() {
  const [configOpen, setConfigOpen] = useState(true);
  const [viewType, setViewType] = useState("on_screen");
  const [assetClass, setAssetClass] = useState("mutual_fund");
  const [investor, setInvestor] = useState("all_selected");
  const [sellDateFrom, setSellDateFrom] = useState("2026-01-12");
  const [sellDateTo, setSellDateTo] = useState("2026-02-12");
  const [applying, setApplying] = useState(false);

  const handleApply = () => {
    setApplying(true);
    setTimeout(() => setApplying(false), 600);
    // TODO: fetch report data based on filters
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9", minHeight: "100vh" }}>
        {/* Header */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <h3 className="mb-2 text-primary">Profit & Loss</h3>
                <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <NavLink to="/overview">Dashboard</NavLink> /
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/reports/profit-loss">Reports</NavLink> /
                    </li>
                    <li className="breadcrumb-item active">Profit & Loss</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>

        {/* Report Configuration (collapsible) */}
        <div className="card shadow-sm mb-4" style={{ borderRadius: "12px", border: "1px solid #e2e8f0", overflow: "hidden" }}>
          <button
            type="button"
            className="card-header bg-white border-bottom d-flex align-items-center gap-2 w-100 text-start p-3"
            style={{ fontWeight: "600", color: "#0f172a", border: "none", cursor: "pointer" }}
            onClick={() => setConfigOpen(!configOpen)}
            aria-expanded={configOpen}
          >
            <i className={`fa fa-${configOpen ? "minus" : "plus"}-square-o`} style={{ fontSize: "1.1rem", color: TEAL }} aria-hidden />
            Report Configuration
          </button>
          {configOpen && (
            <div className="card-body p-4">
              <div className="row g-3 align-items-end">
                <div className="col-12">
                  <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "8px" }}>
                    View Type:
                  </label>
                  <div className="d-flex flex-wrap gap-3">
                    {VIEW_TYPES.map((opt) => (
                      <label key={opt.value} className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                        <input
                          type="radio"
                          name="viewType"
                          value={opt.value}
                          checked={viewType === opt.value}
                          onChange={() => setViewType(opt.value)}
                          style={{ accentColor: TEAL, width: 18, height: 18 }}
                        />
                        <span style={{ fontSize: "15px", color: "#475569" }}>{opt.label}</span>
                      </label>
                    ))}
                  </div>
                </div>
                <div className="col-12">
                  <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "8px" }}>
                    Assets Class:
                  </label>
                  <div className="d-flex flex-wrap gap-3">
                    {ASSET_CLASSES.map((opt) => (
                      <label key={opt.value} className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                        <input
                          type="radio"
                          name="assetClass"
                          value={opt.value}
                          checked={assetClass === opt.value}
                          onChange={() => setAssetClass(opt.value)}
                          style={{ accentColor: TEAL, width: 18, height: 18 }}
                        />
                        <span style={{ fontSize: "15px", color: "#475569" }}>{opt.label}</span>
                      </label>
                    ))}
                  </div>
                </div>
                <div className="col-md-3">
                  <label className="form-label small text-muted">Investor :</label>
                  <select
                    className="form-select form-select-sm"
                    value={investor}
                    onChange={(e) => setInvestor(e.target.value)}
                    style={inputBorderStyle}
                  >
                    <option value="all_selected">All Selected</option>
                    <option value="primary">Primary</option>
                  </select>
                </div>
                <div className="col-md-5">
                  <label className="form-label small text-muted">Sell Date:</label>
                  <div className="d-flex align-items-center gap-2">
                    <div className="input-group input-group-sm">
                
                      <input
                        type="date"
                        className="form-control"
                        value={sellDateFrom}
                        onChange={(e) => setSellDateFrom(e.target.value)}
                        style={inputBorderStyle}
                      />
                    </div>
                    <span className="text-muted">-</span>
                    <div className="input-group input-group-sm">
                 
                      <input
                        type="date"
                        className="form-control"
                        value={sellDateTo}
                        onChange={(e) => setSellDateTo(e.target.value)}
                        style={inputBorderStyle}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4 d-flex justify-content-md-end">
                  <button
                    type="button"
                    className="btn px-4 py-2"
                    style={{
                      background: TEAL,
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      fontWeight: "600",
                      fontSize: "15px",
                    }}
                    onClick={handleApply}
                    disabled={applying}
                  >
                    {applying ? "Applying…" : "Apply"}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Report Data Display */}
        <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e2e8f0", overflow: "hidden" }}>
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead style={{ background: "#f8fafc" }}>
                <tr>
                  {REPORT_COLUMNS.map((col) => (
                    <th key={col.key} style={{ padding: "12px 16px", color: "#64748b", fontWeight: "600", fontSize: "13px", whiteSpace: "nowrap" }}>
                      {col.label}
                      <i className="fa fa-sort ms-1 opacity-75" style={{ fontSize: "10px" }} aria-hidden />
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={REPORT_COLUMNS.length} className="text-center py-5" style={{ color: "#94a3b8" }}>
                    <i className="fa fa-exclamation-triangle d-block mb-2" style={{ fontSize: "2rem" }} aria-hidden />
                    No data available.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
